import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GearAppService, GearTypes } from 'common-gear';
import { AddOnTypes, AppService, ColorPickerService, CommonMapService, CoreProxyService, CoreTypes, FormParametersComponent, FormValidatorService, IncidentsService, LabelValue, Modal, ReplaceLiteralsPipe, SharedCommonService, StringDateTimePipe, TableTypes, Year } from 'common-cloudstudio';
import { Subscription } from 'rxjs';
import { MapService } from '../../shared/services/map.service';
import { MapsAPILoader } from '@agm/core';
import { ToasterService } from 'angular2-toaster';
import { NgForm } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { IncidentTypes } from 'common-cloudstudio';
import { IncidentService } from '../services/incident.service';
import { IncidentElementModalComponent } from '../incident-shared//incident-element-modal/incident-element-modal.component'
import { IncidentLocationRefComponent } from '../incident-shared/incident-location-ref/incident-location-ref.component';
import { IncidentTablesComponent } from '../incident-shared/incident-tables/incident-tables.component';

const PARAMETER_ID_INCIDENT = 9904;
export interface IncidentITSMap extends CoreTypes.IncidentITSMap, CoreTypes.IncidentITSMap_Incident,
CoreTypes.IncidentITSMap_Facility, CoreTypes.IncidentITSMap_Device, CoreTypes.IncidentITSMap_ITSReferencePoints { }

@Component({
  selector: 'app-incident-form',
  templateUrl: './incident-form.component.html',
  styleUrls: ['./incident-form.component.scss'],
})

export class IncidentFormComponent implements OnInit, OnChanges, OnDestroy {
  today = new Date();
  @ViewChild('formElement') public _formElement: NgForm;
  @ViewChild('formElementModal') public _formElementModal: NgForm;
  @ViewChild('detailModal') detailModal: Modal;
  @ViewChild('confirmRemove') private _confirmRemove: Modal;
  @ViewChild('editElementModal') public _editElementModal: any;
  @ViewChild('confirmExitRoute') private _confirmExitRoute: Modal;
  @ViewChild('search') public searchElementRef: ElementRef;
  @ViewChild("file") myFileRef: ElementRef;
  @ViewChild('formParam') formParam: FormParametersComponent;
  @ViewChild('elementModal') private _elementModal: IncidentElementModalComponent;
  @ViewChild('locationForm') private _locationForm: IncidentLocationRefComponent;
  @ViewChild('tablesForm') private _tablesForm: IncidentTablesComponent;
  @ViewChild('attachmentTable') private _attachmentTable: IncidentTablesComponent;

  @ViewChild('mapDetails') _mapDetails: Modal;

  @Input() editing: boolean = false;
  @Input() incidentID: number = 0;
  @Input() displayOnModal: boolean = false;
  @Input() communicationIDs : number[] = [];

  @Output() newMarker = new EventEmitter<any>();
  @Output() cleanMarker = new EventEmitter<boolean>();
  @Output() cleanSearch = new EventEmitter<boolean>();
  @Output() onCenterMap = new EventEmitter<any>();
  @Output() confirmExitRoute = new EventEmitter<any>();
  @Output() incidentClosed = new EventEmitter<any>();
  @Output() onCloseForm = new EventEmitter<any>();

  _confirmSaveChanges: boolean;
  _confirmChangeTab: number = 0;
  _goToChatGroup: number = 0;
  incidentData: CoreTypes.ITS_Incident = new CoreTypes.ITS_Incident();
  subscriptions: Subscription[] = [];
  _successMessage: string;
  _errorMessage: string;
  _errorLocationMessage: string;

  _monthlyID : number = 0;
  _dateCreated : string = "";
  clientID: number;
  facilityID: number;
  _selectedGroup: LabelValue<number>;
  _optionsGroup: LabelValue<number>[] = [];
  _selectedContact: LabelValue<number>;
  _optionsContacts: LabelValue<number>[] = [];
  _contactsFullList: CoreTypes.ExternalInstantMessagingContact[] = [];
  _errorBackEnd = "";
  addOnIncidents: GearTypes.BasicMasterEntityAddOnFeatures = new GearTypes.BasicMasterEntityAddOnFeatures();
  addOnFeatureVisibility = AddOnTypes.AddOnVisibilityTypes;
  addOnFeatureIDs = AddOnTypes.AddOnFeatureIDs;
  addOnIncident:GearTypes.BasicMasterEntityAddOnFeatures = new GearTypes.BasicMasterEntityAddOnFeatures();
  dateTimeCreated: CoreTypes.DateTimeDT = {
    ...new CoreTypes.DateTimeDT(),
    Date: {
      Day: this.today.getDate(),
      Month: this.today.getMonth()+1,
      Year: this.today.getFullYear()
    },
    Time: {
      Hour: this.today.getHours(),
      Minute: this.today.getMinutes(),
      Second: this.today.getSeconds(),
      Millisecond: this.today.getMilliseconds(),
    }
  };
  dateTimeClosed: CoreTypes.DateTimeDT = new CoreTypes.DateTimeDT();
  dateTo: CoreTypes.DateTimeDT = {
    ...new CoreTypes.DateTimeDT(),
    Date: {
      Day: 0,
      Month: 0,
      Year: 0
    },
    Time: {
      Hour: 0,
      Minute:0,
      Second: 0,
      Millisecond:0,
    }
  };

  errorMess:string;
  _prioritiesFullList: CoreTypes.IncidentPriority[] = [];
  _incidentStatusList: LabelValue<number>[] = [];
  _incidentStatusFullList: CoreTypes.IncidentStatus[] = [];
  _incidentStatus: LabelValue<number>;
  _incidentTypeFullList: CoreTypes.IncidentType[] = [];
  _incidentTypeList: LabelValue<number>[] = []
  _incidentSubTypeFullList: CoreTypes.IncidentSubType[]= [];
  _incidentSubTypeList: LabelValue<number>[] = [];
  _incidentOriginFullList: CoreTypes.IncidentOrigin[] = [];
  _vialAxesList: LabelValue<number>[] = [];
  _vialAxesFullList: CoreTypes.ITS_VialAxes[];
  _referenceList: LabelValue<string>[] = [];
  _referenceFullList: CoreTypes.ITS_ReferencePoints[] = [];
  _roadwayList: LabelValue<number>[] = [];
  _roadwayFullList: CoreTypes.ITS_Roadways[] = [];
  _trafficDirectionsFullList:CoreTypes.ITS_TrafficDirection[] = [];
  _trafficDirectionsList: LabelValue<number>[] = [];
  _sectorFullList:CoreTypes.ITS_Sectors[] = [];
  _subSectorFullList:CoreTypes.ITS_SubSectors[] = [];
  _laneFullList: CoreTypes.ITS_Lanes[] = [];
  _assetsFullList: CoreTypes.Asset[] = [];
  _movilList: LabelValue<number>[] = [];
  _externalMovilFullList: CoreTypes.ITS_ExternalAssistanceServices[] = [];
  _externalMovilList: LabelValue<number>[] = [];
  _assistanceFullList: CoreTypes.ITS_AssistanceTypes[] = [];
  _assistanceList: LabelValue<number>[] = [];
  _vehicleModelFullList: CoreTypes.ITS_VehicleModels[] = [];
  _vehicleModelList: LabelValue<number>[] = [];
  _vehicleTypeList: LabelValue<number>[] = [];
  _vehicleColorList: LabelValue<number>[] = [];
  _reasonLaneCloseList: LabelValue<number>[] = [];
  _reasonLaneOpenList: LabelValue<number>[] = [];

  _observations:string;
  menuButtonList: LabelValue<number>[] = [
    { label:  'Guardar y cerrar', value: 2 },
  ];

  _summaryTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _summaryList: any[] = [];
  _notificationGroupTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _notificationGroupList: any[] = [];
  _removeId: number;
  _removeType: string;
  _editId: number;
  _editType: string;
  _editTitle: string;
  _formStatus = 0;
  _loadStatus = 0;
  _loadReference = 0;
  searchControl: string = "";

  incidentPermissions: boolean = true;
  debounceAction: any;
  fileTypeMapping = IncidentTypes.FileTypeMapping;

  incidentColorFullList: CoreTypes.InternalColorWithDefaultGroup[] = [];
  incidentCategoryColorList: LabelValue<number>[] = [];
  incidentCategoryColor: LabelValue<number> = this.incidentCategoryColorList[0];
  notificationGroups: CoreTypes.ITS_IncidentNotificationGroups[] = [];
  groupsMemberList: IncidentTypes.ExternalInstantMessagingContact[] = [];
  disableDeleteButton: boolean = false;

  vehicleDataFullList:CoreTypes.ITS_VehiclesData[] = [];
  personDataFullList:CoreTypes.ITS_Persons[] = [];
  loadDataVehicles = 0;
  loadDataLanes = 0;
  loadAssistances = 0;
  loadAddVehicles = 0;
  loadDataPersons = 0;
  loadAddPersons = 0;

  autocomplete: google.maps.places.Autocomplete;
  geocoder: google.maps.Geocoder;
  modalMarker: google.maps.Marker;
  latitude: number;
  longitude: number;
  eventListener: any;
  bounds: any;
  map: google.maps.Map;
  mapReady: boolean = false;
  coordinates: any = null;

  formParameterList: CoreTypes.FormParameter[];
  formParameterApplied: CoreTypes.FormParameter[] = [];
  paramSelected: CoreTypes.FormParameter = new CoreTypes.FormParameter();
  cloneParams: Array<CoreTypes.FormParameter> = [];
  subscription: Subscription;
  incidentElementTypes = IncidentTypes.elementTypes;
  materialAssetsFullList: CoreTypes.ITS_MaterialAssets[] = [];
  summaryConditions: any;
  firstTime:boolean = true;

  _longitudeCenter: number = -71.86585;
  _latitudeCenter: number = -36.07055;
  _zoom: number = 1.9;
  _pathsUtilityCompanies: any;
  _pathsMaintenanceContractors: any;

  incidentColor: string = '';

  constructor(
    public _mapService: MapService,
    public commonMapService: CommonMapService,
    public _appService: AppService,
    public _gearService: GearAppService,
    public mapsAPILoader: MapsAPILoader,
    private _coreProxyService: CoreProxyService,
    public _formValidatorService: FormValidatorService,
    private ngZone: NgZone,
    private _toasterService: ToasterService,
    public sanitizer: DomSanitizer,
    private cdRef:ChangeDetectorRef,
    private incidentService: IncidentService,
    private incidentsService: IncidentsService,
    private colorService: ColorPickerService,
  ) {
    this.incidentData.Incident = new CoreTypes.SimpleIncident();
    this.incidentData.Incident.Location =  new CoreTypes.GeoCoordinate();
    this.incidentData.ReferencePoint = new CoreTypes.ITS_ReferencePoints();
    this._appService.notLoadTawkTo.next(true);
  }

  ngOnInit(): void {
    this.subscriptions.push(this._gearService.onGearPermissionList.subscribe(permissions => {
      if(permissions){;
        this.incidentPermissions = this._appService.contains(permissions.Monitor.ClientIncidents, CoreTypes.PermissionOperation.Edit);
      }
    }));
    this.subscriptions.push(this._gearService.addOnFeaturesPermissions.subscribe(addOns => {
      if(!addOns || !addOns.length) { return; }
      // this.addOnFeature(addOns);
    }));

    this.subscriptions.push(this._appService.addNewIncident.subscribe((location) => {
      if(location) {
        let latLng = new google.maps.LatLng(location.Latitude, location.Longitude);
        this.onPlaceChange(null, latLng);
        this.setInitData();
      }
    }));
    this.appendModalBody('append');
  }

  ngOnDestroy(): void {
    this.incidentService.cleanVariablesFacility();
    this.incidentService.cleanVariablesClient();
    if(this.subscription) { this.subscription.unsubscribe(); }
    this.subscriptions.forEach(s => s.unsubscribe());
    this._appService.notLoadTawkTo.next(false);
    this.appendModalBody('remove');
  }

  ngOnChanges(data: SimpleChanges) {
    if((data?.incidentID?.currentValue || data?.incidentID?.currentValue !== null) && data?.incidentID?.previousValue !== data?.incidentID?.currentValue) {
      this.incidentID = data?.incidentID?.currentValue;
      this.setInitData();
    }
  }

  getITSIncident(incidentID) {
    this._coreProxyService.IncidentService.GetITSIncident(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      incidentID,
      async success => {
        this.onClickclearText();
        this.incidentData = JSON.parse(JSON.stringify(success));
        this.incidentData.Incident.KilometerPoint = this.incidentData.Incident.KilometerPoint ?? this.incidentData.ReferencePoint.KilometerPoint
        await this.getDispatchedOwnedEmergencyVehicles(incidentID);
        this._monthlyID = success.Incident.MonthlyID;
        this._dateCreated = "";
        if(success.Incident.MonthCreated !== this.dateTimeCreated.Date.Month) {
          this._dateCreated = String(success.Incident.MonthCreated).padStart(2, '0') + '/' + success.Incident.YearCreated;
        }
        this.setIncidentData();
        if(this.incidentData.ReferencePoint?.Latitude){
          this.getITSReferencePoints(this.incidentData.ReferencePoint.Latitude , this.incidentData.ReferencePoint.Longitude, true);
        } else if(this.incidentData.Incident?.Location?.Latitude) {
          this.getITSReferencePoints(this.incidentData.Incident?.Location?.Latitude , this.incidentData.Incident?.Location?.Longitude, true);
        }
      },
      err => {
        this._appService.showException(err);
      }
    )
  }

  getDispatchedOwnedEmergencyVehicles(incidentID: number) {
    this.incidentService.getDispatchedOwnedEmergencyVehicles(incidentID).then((data) => {
      let optionsList: any[] = [];
      data.forEach((x) => {
        let item = { Movil: x?.DisplayDescription, VehicleID: x?.OwnedEmergencyVehicleID,  };
        optionsList.push(item);
      });
      if(!this.incidentService._assistanceDispacthList?.length) this.incidentService._assistanceDispacthList = [];
      this.incidentService._assistanceDispacthList = optionsList;
    }).catch((err) => {
      this._appService.showException(err);
    });
  }

  async setIncidentData() {
    await this.setInitIncidentData();
    this.searchControl = this.incidentData.Incident.LocationAddress?.DisplayText;
    this.coordinates = this.incidentData.Incident?.LocationAddress?.Coordinates ?? this.incidentData.Incident.Location;
    this.dateTimeClosed = this.incidentData.Incident.DateTimeClosed;
    if(!this.incidentData.Incident.LocationAddress?.Coordinates && this.incidentData.Incident.Location?.Latitude) {
      let latLng = this.getLatLng(this.incidentData.Incident.Location.Latitude, this.incidentData.Incident.Location.Longitude)
      this.getFormattedAddress(latLng);
    }
    if(this.incidentData.Dispatches?.length) this.loadAssistances = 1;
    if(this.incidentData.IncidentLanes?.length) this.loadDataLanes = 1;
    if(this.incidentData.IncidentVehicles?.length) this.loadDataVehicles = 1;
    if(this.incidentData.IncidentPersons?.length) this.loadDataPersons = 1;
    if(this.incidentData.Incident?.Observations?.length) this._observations = this.incidentData.Incident?.Observations[this.incidentData.Incident.Observations?.length-1];
    await this.getITSExternalAssistanceServices();

    if(this.incidentData.IncidentVehicles?.length || this.incidentData.IncidentPersons?.length) {
      this.vehicleDataFullList = [];
      this.personDataFullList = [];
      let vehicleList = this.incidentData?.IncidentVehicles?.map(x => { return x.VehicleDataID });
      this.incidentService.getITSVehicles(vehicleList).then(data => {
        this.vehicleDataFullList = data;
        let personList = this.incidentData?.IncidentPersons.map(x => { return x.PersonID });
        if(personList.length) {
          this.incidentService.getITSPersons(personList).then(persons => {
            this.personDataFullList = persons;
            // this.setInvolvedPerson(persons);
            this._tablesForm?.setInvolvedPerson(persons);
            if(this.incidentData.IncidentVehicles?.length) this.loadInvolvedVehicles();
          });
        } else {
          this.loadDataPersons = 0;
          if(this.incidentData.IncidentVehicles?.length) this.loadInvolvedVehicles();
        }
      }).catch(() => {
        this.loadDataVehicles = 2;
        this.loadDataPersons = 2;
      })
    }
    setTimeout(() => {
      this._tablesForm?.setDispatch();
      this._tablesForm?.setDamagedMaterialAssets();
      this._attachmentTable?.setAttachment();
      this.setNotificationGroups();
    }, 500);
  }

  loadInvolvedVehicles() {
    let makesList = this.vehicleDataFullList.map(x => { return x.VehicleMakeID });
    this.incidentService.getITSVehicleModels(makesList).then(models => {
      // this.setInvolvedVehicles();
      this._tablesForm?.setInvolvedVehicles();
    }).catch(error => {
      this.loadDataVehicles = 2;
      this._errorBackEnd = error.Message;
    })
  }

  setNotificationGroups() {
    if(this.incidentData?.NotificationGroups?.length) {
      this.incidentData?.NotificationGroups?.forEach(async a => {
        let group = this.notificationGroups.find(g => g?.IncidentNotificationGroupID === a.GroupID);
        this._notificationGroupList.push({
          Id: a.GroupID,
          Name: a.Name ? a.Name : group?.Name,
          CountMembers: a.MembersIDs.length,
          IncludeAssistanceVehicles: group?.IncludeAssistanceVehicles,
          IncludeAssistanceVehiclesLabel: group?.IncludeAssistanceVehicles ? this._appService.CoreCommonLiterals.WordYes : this._appService.CoreCommonLiterals.WordNo,
          Members: group?.Members,
          HiddeDelete: true
        });
      });
    }
    setTimeout(() => this.onRefreshGrid('notificationGroups'), 100);
  }

  loadGroups(): Promise<void> {
    this._optionsGroup = [];
    let contactsLabelValue = new Array<LabelValue<number>>();
    return new Promise((resolve) => {
      this._coreProxyService.IncidentService.EnumClientEnabledITSIncidentNotificationGroups(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this._appService.getFacilityID(),
        res => {
          this.notificationGroups = res;
          contactsLabelValue.push({label: this._appService.CoreCommonLiterals.None_Male, value: 0 })
          res.forEach(x => {
            let item = {
              label: x.Name,
              value: x.IncidentNotificationGroupID
            }
            contactsLabelValue.push(item);
          });
          this._optionsGroup = contactsLabelValue;
          this._selectedGroup = this._optionsGroup[0];
          resolve();
        },
        e => {
          this._appService.showException(e);
        }
      );
    });
  }

  async loadContacts(groupID?:number) {
    this._optionsContacts = [];
    this.incidentsService.loadContacts().then(async data => {
      this._optionsContacts = await JSON.parse(JSON.stringify(this.incidentsService._contactsList?.value));
      this._selectedContact = this._optionsContacts[0];
      this.groupsMemberList = this._notificationGroupList[groupID].Members.map(g => {
        g.Enabled = !g.Enabled && this._notificationGroupList[groupID]?.HiddeDelete ? false: true;
        g.Checked = true;
        return g;
      });
      this._contactsFullList = data;
    })
  }

  addNotificationGroup(group, defaultGroup?:boolean) {
    if (group && group.value != 0) {
      let exist = this._notificationGroupList.find(x => x.Id == group?.value);
      if (!exist){
        let selectedGroup = this.notificationGroups.find(g => g.IncidentNotificationGroupID === group?.value);
        if(!this.incidentData?.NotificationGroups?.length) this.incidentData.NotificationGroups = [];
        this.incidentData?.NotificationGroups.push({
          ColorID: selectedGroup?.ColorID,
          IncidentID: this.incidentID ? this.incidentID : 0,
          InstantMessagingGroupID: selectedGroup?.IncidentNotificationGroupID,
          IsDefault:selectedGroup?.IsDefault,
          Mask: selectedGroup?.Mask,
          Name: group.Label,
          PlatformType: undefined,
          GroupID: group.value,
          MembersIDs: selectedGroup?.Members?.map(m => { return m.InstantMessagingContactID })
        });

        if(!this._notificationGroupList?.length) this._notificationGroupList = [];
        this._notificationGroupList.push({
          Id: group.value,
          Name: group.label,
          CountMembers: selectedGroup?.Members?.length,
          IncludeAssistanceVehicles: selectedGroup?.IncludeAssistanceVehicles,
          IncludeAssistanceVehiclesLabel: selectedGroup?.IncludeAssistanceVehicles ? this._appService.CoreCommonLiterals.WordYes : this._appService.CoreCommonLiterals.WordNo,
          Members: selectedGroup?.Members,
          HiddeDelete: defaultGroup
        });
      }
    }
    setTimeout(() => {
      this.selectNotificationGroup(this._optionsGroup);
      this._selectedGroup = this._optionsGroup[0];
      this.onRefreshGrid('notificationGroups');
    }, 100);
  }

  selectNotificationGroup(groupList) {
    let exist = this._notificationGroupList.filter(x => groupList.find(l => l.value === x.Id));
    if(exist.length){
      this._optionsGroup.forEach(l => {
        if(exist.find(x => x.Id === l.value)){
          l.disabled = true;
        } else {
          l.disabled = false;
        }
      });
    } else if(this._notificationGroupList?.length) {
      this._optionsGroup.forEach(l => {
        if(!this._notificationGroupList.find(x => x.Id === l.value)){
          l.disabled = false;
        }
      });
    }
    setTimeout(() => {
      this._selectedGroup = this._optionsGroup[0];
    }, 300);
  }

  async getAssets() {
    this._assetsFullList = [];
    this._movilList = [];
    let movilList = await this.incidentService.getAssetsList();
    this._movilList = JSON.parse(JSON.stringify(movilList))
    this._assetsFullList = await this.incidentService._assetsList.value;
  }

  async getITSAssistanceTypes() {
    this._assistanceFullList = [];
    this._assistanceList = [];
    this.incidentService.getAssistenceTypes().then(async assistence => {
      this._assistanceFullList = assistence;
      if(!assistence.length) {
        this.incidentService._assistenceTypeStatus = 0;
        await new Promise(resolve => { setTimeout(() => resolve(null), 1000); });
      }
      this._assistanceList = await this.incidentService._assistenceTypeList.value;
      this.cdRef.detectChanges();
    });
  }

  async getITSExternalAssistanceServices() {
    this._externalMovilList = [];
    this._externalMovilFullList = [];
    this._externalMovilList = await this.incidentService.getITSExternalAssistanceServices();
    this._externalMovilFullList = await this.incidentService._externalServiceList.value;
  }

  setDynamicEntries(columnsConfig, data) {
    const dataEntries: TableTypes.DataTable = {
      Columns: columnsConfig.map(col => ({
        Title: col.title,
        Alignment: col.alignment || 0,
        WidthPixels: col.width || 65
      })),
      Elements: this.formatDynamicElements(columnsConfig, data)
    };
    return dataEntries;
  }

  formatDynamicElements(columnsConfig, elements){
    let retElem = [];
    if (elements && elements.length > 0) {
      retElem = elements.map((x, i) => ({
        ElementID: i,
        Values: columnsConfig.map(col => x[col.key])
      }));
    }
    return retElem;
  }

  async getHealthConditions() {
    let healthConditions = await this.incidentService.getHealthConditions();
    this.summaryConditions = healthConditions.reduce((acc, condition) => {
      acc[condition.HealthConditionID] = condition.ConditionName;
      return acc;
    }, {});
    if(this.firstTime) {
      this.setInjurySummary();
      this.firstTime = false;
    }
  }

  getHealthCondition(condition) {
    if(!this.incidentService._healthConditionList?.value?.length) this.getHealthConditions();
    return this.incidentService._healthConditionList.value.find(x => x.value === condition)??this.incidentService._healthConditionList.value[0];
  }

  async setInjurySummary(vehicleList?) {
    if (!this.summaryConditions) return;
    if(this.incidentData?.IncidentPersons?.length) {
      const summary = {};
      const personVehicleMap = {};
      this.incidentData.IncidentPersonVehicles?.forEach((relation) => {
        personVehicleMap[relation.IncidentPersonID] = relation.IncidentVehicleID;
      });
      this.incidentData.IncidentPersons?.forEach((person) => {
        const vehicleID = personVehicleMap[person.PersonID] || "Sin vehículo";
        const vehicle = this.incidentData.IncidentVehicles?.find(v => v.VehicleDataID === vehicleID);
        const vehicleData = vehicleList?.find(v => v.Id === vehicle?.VehicleDataID);
        const licensePlate = vehicleData ? vehicleData.LicensePlate : "Sin vehículo";
        const conditionName = this.summaryConditions[person.HealthConditionID] || "Unknown";

        if (!summary[vehicleID]) {
          summary[vehicleID] = {
            LicensePlate: licensePlate
          };
          Object.keys(this.summaryConditions)?.forEach((id) => {
            summary[vehicleID][this.summaryConditions[id]] = 0;
          });
        }
        summary[vehicleID][conditionName]++;
      });
      this._summaryList = Object.values(summary);
    } else {
      const initialSummary = {
        LicensePlate: ""
      };
      Object.keys(this.summaryConditions).forEach((id) => {
        initialSummary[this.summaryConditions[id]] = 0;
      });
      this._summaryList = [initialSummary];
    }
    this.onRefreshGrid('summary');
  }

  async getIncidentTypes() {
    this._incidentTypeList = [];
    this._loadStatus = 1;
    this.incidentService.getIncidentTypes().then(async (incidentTypes) => {
      setTimeout(() => { this._loadStatus = 0;}, 50);
      this._incidentTypeFullList = incidentTypes;
      this._incidentTypeList = await this.incidentService._incidentTypeList.value;
      let incidentType = this._incidentTypeList.find(i => i.value === this.incidentData.Incident.TypeID)?? this._incidentTypeList[0];
      if(incidentTypes.length) {
        this.getIncidentSubTypes(incidentType?.value);
      }
      this.getPriorities();
      this.getIncidentStatus();
    });
  }

  getIncidentSubTypes(incidentType) {
    this._incidentSubTypeFullList = [];
    this.cdRef.detectChanges();
    if(!incidentType) return;
    let items: LabelValue<number>[] = [];
    this._coreProxyService.IncidentService.EnumIncidentSubTypes(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      incidentType,
      (data:CoreTypes.IncidentSubType[]) => {
        this._incidentSubTypeFullList = data;
      },
      err => {
        this._appService.showException(err);
      }
    );
  }

  async getColorsAllowedForIncidents() {
    this.incidentsService.getColorsForIncidentsWithGroup().then(async incidentColors => {
      this.incidentColorFullList = incidentColors;
      this.incidentCategoryColorList = await this.incidentsService._colorsWithGroupList?.value;
      this.incidentID ? this.incidentCategoryColor = this.incidentCategoryColorList?.find(i => i.value === this.incidentData?.Incident?.ColorID) :
      this.incidentCategoryColor = this.incidentCategoryColorList?.find(i => i.value === this._appService.client?.Client?.IncidentSettings?.DefaultIncidentColorID)?? this.incidentCategoryColorList[0];
      if(!this.incidentID) {
        await new Promise(resolve => { setTimeout(() => resolve(null), 200); });
        this.setGroupByCategory()
      }
    });
  }

  async getIncidentOriginList() {
    this._incidentOriginFullList = await this.incidentService.getITSIncidentOrigins();
  }

  setGroupByCategory() {
    let groupID = this.incidentColorFullList?.find(x => x.ColorID ==  this.incidentCategoryColor?.value)?.GroupID;
    let findGroup = this.notificationGroups?.find(g => g.IncidentNotificationGroupID == groupID);
    if(findGroup) {
      this._selectedGroup = {label: findGroup?.Name, value: findGroup?.IncidentNotificationGroupID}
      this.addNotificationGroup(this._selectedGroup, true)
    }
  }

  onChangeCategory() {
    if(!this.incidentID) {
      setTimeout(() => {
      let groupID = this.incidentColorFullList?.find(c => c.ColorID === this.incidentData?.Incident?.ColorID)?.GroupID;
      if(this._notificationGroupList[0]?.Id && groupID && this._notificationGroupList[0].Id !== groupID) {
        let findGroup = this.notificationGroups?.find(g => g.IncidentNotificationGroupID == groupID);
        let findIndex =  this.incidentData.NotificationGroups?.findIndex(x => x.GroupID === this._notificationGroupList[0].Id);
        this._notificationGroupList[0].Id = groupID;
        this._notificationGroupList[0].CountMembers = findGroup?.Members?.length;
        this._notificationGroupList[0].HiddeDelete = true;
        this._notificationGroupList[0].IncludeAssistanceVehicles = findGroup?.IncludeAssistanceVehicles;
        this._notificationGroupList[0].IncludeAssistanceVehiclesLabel = findGroup?.IncludeAssistanceVehicles ? this._appService.CoreCommonLiterals.WordYes : this._appService.CoreCommonLiterals.WordNo,
        this._notificationGroupList[0].Members = findGroup?.Members;
        this._notificationGroupList[0].Name = findGroup?.Name;
        if(findIndex > -1){
          this.incidentData.NotificationGroups[findIndex].GroupID = this._notificationGroupList[0].Id;
          this.incidentData.NotificationGroups[findIndex].MembersIDs = this._notificationGroupList[0].Members.map(m => { return m.InstantMessagingContactID });
        }
        this.onRefreshGrid('notificationGroups');
      } else if(!this._notificationGroupList.length) {
        this.setGroupByCategory()
      }
      }, 100);

    }
  }

  getITSRoadways() {
    this._roadwayFullList = [];
    this.incidentService.getITSRoadways().then(async roadwayList => {
      this._roadwayFullList = roadwayList;
      await this.incidentService._roadwaysList.value;
      this.onSelectVialAxes();
    });
  }

  getITSReferencePoints(lat, lng, isEditing?) {
    // if(this.incidentPermissions && (this.addOnIncidents.Enabled ||
    //   (!this.addOnIncidents.Enabled && this.addOnIncidents.Visibility === this.addOnFeatureVisibility.Visible ||
    //   this.addOnIncidents.Visibility === this.addOnFeatureVisibility.ShowStar
    // ))) {
      this._loadReference = 1;
      this._referenceFullList = [];
      this.incidentService._referenceFullList = [];
      this._referenceList = [];
      // this._reference = null;
      // this._kilometer = null;
      this.incidentService._reference = null;
      this.cdRef.detectChanges();

      this._coreProxyService.IncidentService.SearchITSReferencePoints(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this._appService.getFacilityID(),
        lat,
        lng,
        data => {
          this._referenceFullList = data;
          this.incidentService._referenceFullList = data;
          this.latitude = lat;
          this.longitude = lng;
          if(data.length) {
            let referenceItems: LabelValue<string>[] = [];
            data.forEach((i) => {
              const ref = {
                label: i.Reference,
                value: i.ReferencePointID + ' ' +i.Roadway.RoadwayID,
              }
              // if(referenceItems.length === 0) {
              //   // this._reference = ref;
              //   this.incidentService._reference = ref;
              // }
              referenceItems.push(ref);
            });
            this._referenceList = referenceItems;
            let findReference = (isEditing && this.incidentData.Incident.KilometerPoint) ? (data.find(x => x.KilometerPoint === this.incidentData.Incident.KilometerPoint) ?? data[0]) : data[0];
            if(findReference.KilometerPoint) this.incidentData.Incident.KilometerPoint = findReference.KilometerPoint;
            if(findReference.VialAxisID) this.incidentData.Incident.VialAxisID = findReference.VialAxisID;
            if(findReference.RoadwayID) this.incidentData.Incident.RoadwayID = findReference.RoadwayID;
            if(findReference.DirectionID) this.incidentData.Incident.TrafficDirectionID = findReference.DirectionID;
            
            this.cdRef.detectChanges();
            // if(!this.incidentID) {
            //   this._reference = this._referenceList[0];
            //   this.incidentService._reference = this._referenceList[0];
            // }
            // this.cdRef.detectChanges();
            // if(!isEditing) this.onSelectRoadway();
          }
          this._loadReference = 0;
        },
        err => {
          this.latitude = lat;
          this.longitude = lng;
          this._loadReference = 2;
          this._appService.showException(err);
        }
      );
    // }
  }

  // onSelectReference(data) {
  //   this._referenceList = [];
  //   this._kilometer = null;
  //   this.cdRef.detectChanges();
  //   if(data.length) {
  //     let referenceItems: LabelValue<string>[] = [];
  //     data.forEach((i) => {
  //       const ref = {
  //         label: i.Reference,
  //         value: i.ReferencePointID + ' ' +i.Roadway.RoadwayID,
  //       }
  //       if(referenceItems.length === 0) {
  //         this._reference = ref;
  //         this.incidentService._reference = ref;
  //         this._kilometer = i.KilometerPoint;
  //       }
  //       referenceItems.push(ref);
  //     });
  //     this._referenceList = referenceItems;
  //     if(!this.incidentID) {
  //       this._reference = this._referenceList[0];
  //       this.incidentService._reference = this._referenceList[0];
  //     }
  //     this.cdRef.detectChanges();
  //     // this.onSelectRoadway();
  //   }
  // }

  // onSelectRoadway() {
  //   if(!this._reference?.value) return;
  //   this.incidentService._reference = this._reference;
  //   const reference = this._referenceFullList.filter(item => item.ReferencePointID === +(this._reference.value.split(' ')[0]));
  //   const referenceSelect =  this._referenceFullList.find(item => item.ReferencePointID === +(this._reference.value.split(' ')[0]));
  //   let rodwayItems: LabelValue<number>[] = [];
  //   let itemsClone: LabelValue<number>[] = [];
  //   let location = new google.maps.LatLng(referenceSelect.Latitude, referenceSelect.Longitude);
  //   if(this._kilometer !== referenceSelect.KilometerPoint) {
  //     this.cleanMarker.emit(true)
  //     this.newMarker.emit({Location: location, Animation: true});
  //   }

  //   if(reference.length) {
  //     reference.map(r => {
  //       this._kilometer = r.KilometerPoint;
  //       const item = {
  //         label: r.Roadway.Description,
  //         value: r.RoadwayID
  //       };
  //       rodwayItems.push(item);
  //       itemsClone.push(item);
  //     });
  //   }
  //   this._roadwayList = rodwayItems;
  //   this._laneRoadwayList = itemsClone;
  //   this._roadway = null;
  //   this._roadway = this._roadwayList.find(x => x.value === this.incidentData?.Incident?.RoadwayID) ?? this._roadwayList[0];
  //   this.incidentService._roadway = this._roadway;
  //   this._laneRoadway = this._roadway;
  //   this.cdRef.detectChanges();
  // }

  async onSelectVialAxes() {
    this._vialAxesFullList = await this.incidentService.getITSVialAxes();
    let items: LabelValue<number>[] = [];
    this._vialAxesFullList?.forEach((i) => {
      const item = {
        label: i.VialAxisName,
        value: i.VialAxisID,
      };
      items.push(item);
    });
    this._vialAxesList = items;
    this.incidentService._vialAxesList = items;
    this.cdRef.detectChanges();
  }

  async onSelectTrafficDirection() {
    this._trafficDirectionsList = await this.incidentService.getITSTrafficDirections();
    this._trafficDirectionsFullList = await this.incidentService._trafficDirectionsList.value;
    this.cdRef.detectChanges();
  }

  async getSectorList() {
    this._sectorFullList = [];
    this._sectorFullList = await this.incidentService.getSectorList();
    let sectorList = await this.incidentService._sectorList.value;
    const sector =  sectorList.find(s => s.value ===  this.incidentData?.Incident?.SectorID) ?? sectorList[0];
    this.cdRef.detectChanges();
    this.getSubSectorList(sector?.value);
  }

  getSubSectorList(sectorID: number) {
    if(!sectorID) return;
    this._subSectorFullList = [];
    this._coreProxyService.IncidentService.EnumITSSubSectorsBySectorID(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      sectorID,
      (data:CoreTypes.ITS_SubSectors[]) => {
        this._subSectorFullList = data;;
      },
      err => {
        this._appService.showException(err);
      }
    );
  }

  async  getITSLanes() {
    this._laneFullList = [];
    this.cdRef.detectChanges();
    this.incidentService.getITSLanes().then( async data =>{
      this._laneFullList = data;
      this._trafficDirectionsList = await this.incidentService.getITSTrafficDirections();
      if(this.incidentID && this.incidentData?.IncidentLanes?.length) {
        await this.getITSReasonsClosing();
        await this.getITSReasonsOpening();
      }
      await new Promise(resolve => { setTimeout(() => resolve(null), 1000); });
      this._tablesForm?.setIncidentLanes();
    });
  }

  async getPriorities() {
    this._prioritiesFullList = await this.incidentService.getPriorities();
  }

  getIncidentStatus() {
    this._incidentStatusFullList = [];
    this.incidentService.getIncidentStatus().then(async (incidentTypes) => {
      this._incidentStatusFullList = incidentTypes;
      this._incidentStatusList = await this.incidentService._incidentStatusList.value;
      let findStatus = this._incidentStatusFullList?.find(x => x.MultiLanguageDescription.EN_US = 'Initial state.');
      this._incidentStatus = this._incidentStatusList.find(i => i.value === this.incidentData.Incident.ActualStatusID || i.label === 'Open')?? { label: findStatus?.Description, value: findStatus?.IncidentStatusID }
    });
  }

  setObservations() {
    if(!this.incidentID) {
      this.incidentData.Incident.Observations = [];
    } else if(this.incidentData.Incident.Observations.length){
      if(this.incidentData.Incident.Observations.find(x => x === this._observations)) return;
    }
    this.incidentData.Incident.Observations.push(this._observations)
  }

  async openEditModal(id, editType, title) {
    this._editId = id;
    this._editType = editType;
    this._editTitle = title;
    this.updateMaxDate();
    switch (this._editType) {
      case 'group':
        let groupID = this._notificationGroupList[id].Id;
        this.loadContacts(id);
        break
      default:
        break;
    }
    this._editElementModal.open();
  }

  openRemoveModal(id, removeType) {
    this.disableDeleteButton = true;
    this._removeId = id;
    this._removeType = removeType;
    this._confirmRemove.open();
  }

  remove() {
    switch (this._removeType) {
      case 'group':
      if(this._optionsGroup.find(x => x.value == this._notificationGroupList[this._removeId].Id)) {
        this._optionsGroup.find(x => x.value == this._notificationGroupList[this._removeId].Id).disabled = false;
      }
      this._notificationGroupList.splice(this._removeId, 1);
      this.incidentData.NotificationGroups?.splice(this._removeId, 1);
      this.onRefreshGrid('notificationGroups');
      break
      default:
        break;
    }
    this.disableDeleteButton = false;
    this._confirmRemove.close();
  }

  async onConfirmEdit() {
    switch (this._editType) {
      case 'group':
        this.onEditNotificationGroups(this._editId);
        this._editElementModal.close();
        break;
      default:
        break;
    }
  }

  onEditNotificationGroups(Id) {
    this._notificationGroupList[Id].Members = this.groupsMemberList.filter(g => g.Checked === true);
    this._notificationGroupList[Id].CountMembers = this._notificationGroupList[Id]?.Members?.length;
    this.incidentData.NotificationGroups[Id].MembersIDs = this._notificationGroupList[Id].Members.map(g => { return g.InstantMessagingContactID }  );
    this.onRefreshGrid('notificationGroups');
  }

  async getITSReasonsClosing() {
    await this.incidentService.getITSReasonsClosing();
    this._reasonLaneCloseList = await this.incidentService._reasonCloseList.value;
  }

  async getITSReasonsOpening() {
    await this.incidentService.getITSReasonsOpening();
    this._reasonLaneOpenList = await this.incidentService._reasonOpenList.value;
  }

  onRefreshGrid(item){
    switch(item) {
      case 'summary':
        const summaryColumnsConfig = [
          { title: 'Patente', key: 'LicensePlate', alignment: 0 }
        ];
        if(this.summaryConditions) {
          Object.keys(this.summaryConditions)?.forEach(id => {
            const conditionName = this.summaryConditions[id];
            summaryColumnsConfig.push({
              title: conditionName,
              key: conditionName,
              alignment: 2
            });
          });
        }
        this._summaryTable = this.setDynamicEntries(summaryColumnsConfig, this._summaryList);
      break;
      case 'notificationGroups':
        const groupsColumnsConfig = [
          { title: this._appService.CoreCommonLiterals?.Name, key: 'Name' },
          { title: this._appService.CoreCommonLiterals?.MemberCount, key: 'CountMembers', alignment: 2 },
          { title: 'Incluye Vehículos de asistencia', key: 'IncludeAssistanceVehiclesLabel', alignment: 2 },
        ];
        this._notificationGroupTable = this.setDynamicEntries(groupsColumnsConfig, this._notificationGroupList);
        break;
      default:
        break;
    }
  }

  goToGroup() {
    this._confirmRemove.close();
  }

  onConfirmExitRoute(value, confirmSaves) {
    if(value) {
      this.onSave(this._formElement)
    } else{
      this.cleanForm();
      this.onCloseForm.emit(true);
    }
    this._confirmExitRoute.close();
    if(!this._appService.collapsibleSidebarIsOpen() && !confirmSaves) { setTimeout(() => this._appService.collapsibleSidebarToggler(), 200);  }
  }

  onConfirmChangeTab(save) {
    if(save) {
      this.onSave(this._formElement, null, true)
    } else {
      this.setInitData();
      this.cleanForm(true);
    }
    this.confirmExitRoute.emit({OnConfirmExitRoute: true});
    this._confirmChangeTab = 0;
    this._confirmExitRoute.close();
    if(this._goToChatGroup)  {
      this.incidentsService._goToChatGroup.next(this._goToChatGroup);
      this._goToChatGroup = 0;
    }
  }

  onConfirmSave() {
    this._confirmSaveChanges = true;
    this._confirmExitRoute.open();
  }

  async onSave(formElement, close?: any, collapsible?:boolean) {
    this._errorBackEnd = "";
    this._confirmSaveChanges = false;
    if (formElement && !formElement.form.valid) {
      this._formElement.form.markAllAsTouched();
      this._errorBackEnd = this._formValidatorService.getValidationErrors(formElement);
      return;
    }
    this._formStatus = 1; // Loading
    if(!this.incidentData.Incident?.Location?.Longitude) this.incidentData.Incident.Location = new CoreTypes.GeoCoordinate();
    this.incidentData.Incident.Location.Latitude = this.latitude;
    this.incidentData.Incident.Location.Longitude = this.longitude;
    this.incidentData.ReferencePoint = new CoreTypes.ITS_ReferencePoints();
    this.incidentData.ReferencePoint = {
      KilometerPoint: this.incidentData.Incident.KilometerPoint,
      Latitude: this.incidentData.Incident.Location?.Latitude,
      Longitude: this.incidentData.Incident.Location?.Longitude,
      RoadwayID: this.incidentData.Incident.RoadwayID,
      ReferencePointID: this.incidentData.ReferencePoint.ReferencePointID,
      DirectionID: this.incidentData.Incident.TrafficDirectionID,
      VialAxisID: this.incidentData.Incident.VialAxisID
    }

    if(!this.incidentData.Incident?.Observations?.length && !this._observations) {
      this.incidentData.Incident.Observations = [];
    }
    if(this.incidentData.Incident.TypeID && this._prioritiesFullList.length) {
      this.incidentData.Incident.ActualPriorityID = this._incidentTypeFullList.find(p => p.IncidentTypeID === this.incidentData.Incident.TypeID ).Priority;
    }

    if(this._incidentStatus?.value) {
      this.incidentData.Incident.ActualStatusID = this._incidentStatus?.value;
    }

    if(close) {
      let element = close.target as Element;
      if(!this.incidentID || this.menuButtonList.find(m => m.value === +element.id).value == 2) {
        this.incidentData.Incident.ClosedByAccountID = this._appService.getAccountID();
        this.incidentData.Incident.DateTimeClosed = this.dateTimeCreated;
      } else if(this.menuButtonList.find(m => m.value === +element.id).value == 3) {
        this.incidentData.Incident.DateTimeClosed = this.dateTimeCreated;
        this.incidentData.Incident.DateTimeDeleted =  this.dateTimeCreated;
      }
    }

    this.incidentData.Incident.AssignedAccountID = this._appService.getAccountID();
    this.incidentData.Incident.FacilityID = this._appService.getFacilityID();
    this.incidentData.Incident.ClientID = this._appService.getClientID();
    this.incidentData.Incident.Enabled = true;
    if(!this.incidentData.IncidentLanes?.length) this.incidentData.IncidentLanes = [];
    if(!this.incidentData.IncidentVehicles?.length) this.incidentData.IncidentVehicles = [];
    if(!this.incidentData.IncidentPersonVehicles?.length) this.incidentData.IncidentPersonVehicles = [];
    if(!this.incidentData.IncidentPersons?.length) this.incidentData.IncidentPersons = [];
    if(!this.incidentData.Incident.Evidence?.length) this.incidentData.Incident.Evidence = [];
    if(this.dateTimeClosed?.Date?.Day) this.incidentData.Incident.DateTimeClosed = this.dateTimeClosed;

    if(this.incidentID) {
      this._coreProxyService.IncidentService.EditITSIncident(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        this.incidentData,
        data => {
          this.incidentData = data;
          this.incidentService._vehicleModelsFullList.value.length = 0;
          this.incidentService._vehicleModelsStatus = 0;
          this.incidentService._vehicleTypesFullList.value.length = 0;
          this.incidentService._vehicleTypesStatus = 0;
          this._toasterService.pop('success', null, this._appService.CoreCommonLiterals.ChangesSavedSuccessfully + ' - ' + 'Evento' + ' #' + this._monthlyID);
          setTimeout(() => {
            this._formStatus = 0;
            if(this.displayOnModal) {
              this.onCloseForm.emit(true);
              this.incidentService.onRefreshIncidentList.next(true);
              this.incidentService.onRefreshCommunicationList.next(true);
            }
            if(!this._appService.collapsibleSidebarIsOpen() && !collapsible) {
              this._appService.collapsibleSidebarToggler();
            }
          }, 200);
        },
        err => {
          if(err.StatusCode === 413 && !err.Message) {
            err.Message = this._appService.CoreCommonLiterals?.NetworkErrorPayloadToLarge;
          }
          this._errorBackEnd = err.Message;
          this._appService.showException(err);
          this._formStatus = 2;
        }
      )
    } else {
      this.incidentData.Incident.DateTimeCreated = this.dateTimeCreated;
      this.incidentData.Incident.CreatedByAccountID = this._appService.getAccountID();
      this.incidentData.Incident.AccountLastPriorityChange = this._appService.getAccountID();
      this.incidentData.Incident.LocationApprovedAccount = this._appService.getAccountID();
      if(this.incidentData.Incident?.ActualPriorityID) {
        this.incidentData.Incident.OriginalPriorityID = this._prioritiesFullList?.find(p => p.IncidentPriorityID === this.incidentData.Incident?.ActualPriorityID).IncidentPriorityID;
      }
      this.incidentData.Incident.PrimaryVariableInformation = '';
      this.incidentData.Incident.Source = 4;
      this._coreProxyService.IncidentService.CreateITSIncident(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        this.incidentData,
        this.communicationIDs,
        data => {
          let monthlyID = data.Incident.MonthlyID.toString();
          let incidentID = data.Incident.IncidentID.toString();
          this.formParameterApplied?.forEach(x => {
            if(x.ParameterType == CoreTypes.FormParameterType.MultiStringList && x.ParameterID == PARAMETER_ID_INCIDENT){
              x.ValueMultiString?.push(incidentID);
              x.RefreshOnChange = true;
              x.AllowedValues?.push({Name: 'Incidente #'+ monthlyID + ' ' + '('+incidentID+')', Value: incidentID });
            }
          });

          this.incidentData = data;
          this.incidentService._vehicleModelsFullList.value.length = 0;
          this.incidentService._vehicleModelsStatus = 0;
          this.incidentService._vehicleTypesFullList.value.length = 0;
          this.incidentService._vehicleTypesStatus = 0;
          if(data.Incident.Observations.length) {
            this._observations = data.Incident.Observations[data.Incident.Observations.length -1];
          }
          this.setButtonList();
          this._toasterService.pop('success', null, this._appService.CoreCommonLiterals.ChangesSavedSuccessfully + ' - ' + 'Evento' + ' #' + monthlyID);
          setTimeout(() => {
            this._formStatus = 0;
            if(this.displayOnModal) {
              this.onCloseForm.emit(true);
              this.incidentService.onRefreshIncidentList.next(true);
              this.incidentService.onRefreshCommunicationList.next(true);
            }
            if(!this._appService.collapsibleSidebarIsOpen()) { this._appService.collapsibleSidebarToggler(); }
          }, 200);
          this.cleanMarker.emit(true);
        },
        err => {
          if(err.StatusCode === 413 && !err.Message) {
            err.Message = this._appService.CoreCommonLiterals?.NetworkErrorPayloadToLarge;
          }
          this._errorBackEnd = err.Message;
          this._formStatus = 2;
        }
      )
    }
  }

  setButtonList() {
    if(!this.incidentData.Incident?.DateTimeClosed?.Date?.Day){
      this.menuButtonList = [
        { label: 'Guardar y cerrar', value:2},
        { label: 'Guardar y cancelar', value:3}
      ]
      this.incidentClosed.emit(false);
    } else {
      this.menuButtonList = [
        { label: 'Guardar y cancelar', value:3}
      ];
      this.incidentClosed.emit(true);
    }
  }

  autocompleteFocus(event) {
    this.mapsAPILoader.load().then(async () => {
      this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement, {
        types: ["address"]
      });
      this.autocomplete.addListener("place_changed", (e) => {
        this.ngZone.run(() => {
          clearTimeout(this.debounceAction);
          this.debounceAction = setTimeout(() => {
            let place: google.maps.places.PlaceResult = this.autocomplete.getPlace();
            if (place?.geometry === undefined || place?.geometry === null) {
              return;
            }

            if(!this.displayOnModal) this.cleanContextMenu();
            this.onPlaceChange(this.autocomplete.getPlace());
            if(place.photos && place.photos[0]) {
              // console.log(place, "PLACE", place.photos[0]?.getUrl({'maxWidth': 500, 'maxHeight': 500}));
            }
          }, 300)
        });
      });
    });
  }

  isCoordinates(input) {
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      const coordinatePattern = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?((1[0-7]\d(\.\d+)?|180(\.0+)?|[1-9]?\d(\.\d+)?))$/;
      coordinatePattern.test(input);
      if(coordinatePattern.test(input)) {
        let coordinates = input.replace(/[\(\)]/g,'').split(',');
        if(coordinates[0].length >= 8 && coordinates[1].length >= 8) {
          let geometry = new google.maps.LatLng(+coordinates[0], +coordinates[1]);
          this.onPlaceChange(null, geometry);
        }
      }
    }, 500)
  }

  async onPlaceChange(place: google.maps.places.PlaceResult, latLong?, searchReference?:boolean) {
    let location;
    place ? location = place.geometry?.location : location = latLong;
    this.onCenterMap.emit(location);
    this.cleanMarker.emit(true);
    this.newMarker.emit({Location: location, Animation: true});
    this.incidentData.Incident.LocationAddress = new CoreTypes.GeocodingAddress();
    if(place?.formatted_address) {
      this.incidentData.Incident.LocationAddress = await this.resolveGeocodingText(place.formatted_address);
    } else {
      this.getFormattedAddress(location);
    }
    this.coordinates = this.incidentData.Incident?.LocationAddress?.Coordinates ?? this.incidentData.Incident.Location;
    if(searchReference) return;
    this.getITSReferencePoints(location.lat(), location.lng());
  }

  onClickclearText() {
    this.cleanSearch.emit(true);
    this._referenceList = [];
    this.searchControl = "";
    this.coordinates = null;
    this._errorBackEnd = "";
    if(this.searchElementRef.nativeElement) {
      this.searchElementRef.nativeElement.value = "";
      this.searchElementRef?.nativeElement?.focus();
    }
    this.cleanNewMarker(true);
    this.cdRef.detectChanges();
  }

  getFormattedAddress(latLng) {
    this.geocoder = new google.maps.Geocoder();
    this.geocoder.geocode({ location: latLng }, async (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          this.searchControl = results[0].formatted_address;
          this.incidentData.Incident.LocationAddress = await this.resolveGeocodingText(results[0].formatted_address);
          this.coordinates = this.incidentData.Incident?.LocationAddress?.Coordinates ?? this.incidentData.Incident.Location;
        }
      }
    });
  }

  getPlacePosition(marker, latLng, changeFilter?:boolean) {
    this.geocoder = new google.maps.Geocoder();
    this.geocoder.geocode({ location: latLng }, async (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          marker?.setPosition(latLng);
          if(changeFilter) {
            this.searchControl = results[0].formatted_address;
            this.incidentData.Incident.LocationAddress = new CoreTypes.GeocodingAddress();
            this.incidentData.Incident.LocationAddress = await this.resolveGeocodingText(results[0].formatted_address);
            this.coordinates = {Latitude : latLng.lat(), Longitude : latLng.lng()};
            this.getITSReferencePoints(latLng.lat(), latLng.lng());
          }
        }
      }
    })
    setTimeout(() => { if(this.eventListener) this.eventListener.remove();}, 10);
  }

  async setPlacePosition(results, latitude, longitude) {
    this.searchControl = results[0].formatted_address;
    this.incidentData.Incident.LocationAddress = new CoreTypes.GeocodingAddress();
    this.incidentData.Incident.LocationAddress = await this.resolveGeocodingText(results[0].formatted_address);
    this.coordinates = this.incidentData.Incident?.LocationAddress?.Coordinates ?? this.incidentData.Incident.Location;
    this.getITSReferencePoints(latitude, longitude);
  }

  resolveGeocodingText(searchText): any {
    return new Promise((resolve, reject) => {
      this._coreProxyService.GeoService.ResolveGeocodingText(
        this._appService.getAccessToken(),
        searchText,
        (success) => {
          resolve(success[0]);
        },
        (error) => {
          reject(error);
          this._appService.showException(error);
        }
      )
    })
  }

  exitEditing(event, groupPos?:number) {
    this.confirmExitRoute.emit({ExitEditing: event});
    this._confirmChangeTab = event;
    if(groupPos) this._goToChatGroup = this.incidentData?.NotificationGroups[groupPos]?.GroupID;
    this._confirmExitRoute.open();
  }

  applyFilters(controlName:string) {
    this.today = new Date();
  }

  setInitData(incidentID?) {
    console.log();
    
    if(incidentID && this.incidentID == incidentID) return;
    if(!this.searchControl && this.searchElementRef?.nativeElement) {
      this.searchElementRef.nativeElement.value = '';
      this.searchElementRef.nativeElement.blur();
    }
    this.cleanTableList();
    this.updateCurrentDates();
    if(incidentID) this.incidentID = incidentID;
    this.incidentID ? this.editIncident() : this.setInitIncidentData();
    setTimeout(() => this.searchElementRef?.nativeElement?.focus(), 100);
  }

  setInitIncidentData() {
    this.getITSRoadways();
    this.getSectorList();
    this.getIncidentTypes();
    this.getHealthConditions();
    this.onSelectTrafficDirection();
    this.getColorsAllowedForIncidents();
    this.getIncidentOriginList();
    this.getITSAssistanceTypes();
    this.getAssets();
    this.loadGroups();
    this.getIncidentMaterialAssets();
    this.getITSLanes();
    this.setButtonList();
    this.incidentService.getSelection(this.incidentElementTypes.Dispatches).next([]);
    this.incidentService.getSelection(this.incidentElementTypes.Lanes).next([]);
    this.incidentService.getSelection(this.incidentElementTypes.InvolvedVehicles).next([]);
    this.incidentService.getSelection(this.incidentElementTypes.InvolvedPeople).next([]);
    this.incidentService.getSelection(this.incidentElementTypes.DamageRegister).next([]);
  }

  refreshTabsData() {
    this.onRefreshGrid('summary');
    this.onRefreshGrid('notificationGroups');
  }

  async editIncident() {
    this.getITSIncident(this.incidentID);
  }


  cleanContextMenu() {
    this._appService.closeIncidentMenu();
    this._errorBackEnd = "";
    // this.map.setOptions({ scrollwheel: true, draggable:true })
  }

  addOnFeature(addOnFeatures: GearTypes.BasicMasterEntityAddOnFeatures[]) {
    this.addOnIncidents = addOnFeatures.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.IncidentManagement);
  }

  updateCurrentDates() {
    this.today = new Date();
    this.dateTimeCreated = {
      ...new CoreTypes.DateTimeDT(),
      Date: {
        Day: this.today.getDate(),
        Month: this.today.getMonth()+1,
        Year: this.today.getFullYear()
      },
      Time: {
        Hour: this.today.getHours(),
        Minute: this.today.getMinutes(),
        Second: this.today.getSeconds(),
        Millisecond: this.today.getMilliseconds(),
      }
    };
  }

  updateMaxDate() {
    this.today = new Date();
  }

  async getIncidentMaterialAssets() {
    await this.incidentService.getIncidentMaterialAssets();
    this.materialAssetsFullList = await this.incidentService._materialAssetsFullList.value;
  }

  cancelForm() {
    if(this.searchControl) {
      this._confirmExitRoute.open()
    } else{
      this.cleanForm();
      this.onCloseForm.emit(true);
    }
    if(!this.searchControl && !this._appService.collapsibleSidebarIsOpen()) this._appService.collapsibleSidebarToggler();
  }

  cleanForm(openSidebar?:boolean) {
    this.incidentID = 0;
    this._monthlyID = 0;
    this.incidentData = new CoreTypes.ITS_Incident();
    this.incidentData.Incident = new CoreTypes.SimpleIncident();
    this.incidentData.Dispatches = [];
    this.incidentData.ReferencePoint = new CoreTypes.ITS_ReferencePoints();
    this._observations = "";
    this.cleanTableList();
    this.onClickclearText();
  }

  cleanTableList() {
    this._notificationGroupTable = new TableTypes.DataTable();
    this._notificationGroupList = [];
    this._summaryList = [];
    this.dateTimeClosed = null;
    setTimeout(() => {
      this._tablesForm?.cleanTableList();
      this._attachmentTable?.cleanTableList();
    }, 100);
    
    this.refreshTabsData();
  }

  getLatLng(lat, lng) {
    return new google.maps.LatLng(lat, lng);
  };

  onMapReady($event) {
    this.map = $event;
    this.mapReady = true;
  }

  mapClicked(event) {
    google.maps.event.addListener(this.map, 'dblclick', (e) => {
      clearTimeout(this.debounceAction);
    });

    this.eventListener = google.maps.event.addListener(this.map, 'click', (e) => {
      clearTimeout(this.debounceAction);
      this.debounceAction = setTimeout(() => {
        var lat = e.latLng.lat();
        var lng = e.latLng.lng();
        this.geocoder = new google.maps.Geocoder();

        this.setNewMarker(this.getLatLng(lat, lng), this.incidentID);
        if(this.modalMarker) this._errorLocationMessage = "";
      }, 300)
    });
  }

  openLocationMap() {
    setTimeout(() => {
      this.setMarkerLocation();
      this._mapDetails.open();
    }, 100);
  }

  setMarkerLocation() {
    if (this.coordinates?.Latitude != null && this.coordinates?.Longitude != null) {
      const latLng = new google.maps.LatLng(this.coordinates.Latitude, this.coordinates.Longitude);
      this.setNewMarker(latLng, this.incidentID);
      this.centerMap(latLng)
    } else {
      const southWest = { lat: -36.6066, lng: -72.1028 }; // Chillán
      const northEast = { lat: -35.5345, lng: -71.6289 }; // (Talca)
      this.bounds = new google.maps.LatLngBounds(southWest, northEast);
      this.map.fitBounds(this.bounds);
    }
    this.map.setZoom(11)

  }

  setNewMarker(location:google.maps.LatLng, incidentID: number) {
    let categoryColor = this.incidentColorFullList?.find(c => c.ColorID == this.incidentData?.Incident?.ColorID)?.ColorCode;
    const color = incidentID ? this.colorService.rgbToHexa(categoryColor) : 'gray';
    if(this.modalMarker) {
      this.cleanNewMarker(true);
    }
    this.modalMarker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: this.pin(color),
      draggable: !incidentID ? true : false
    });
  }

  pin(color, circle?:boolean) {
    let path;
     circle ? path = "M-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" : path = 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0';
    return {
      path :path,
      fillColor: color,
      fillOpacity: 1,
      strokeColor: '#000',
      strokeWeight: circle ? .1 : .5,
      scale: 1,
    };
  }

  centerMap(location) {
    this.map.setCenter(location);
  }

  cleanNewMarker(event) {
    if(event && this.modalMarker) {
      this.modalMarker.setMap(null);
      this.modalMarker = null;
    }
  }

  onSaveLocation() {
    this._errorLocationMessage = "";
    let latLng = this.modalMarker?.getPosition();
    if (latLng) {
      this.getPlacePosition(this.modalMarker, latLng, true);
      this._mapDetails.close();
    } else {
      this._errorLocationMessage = "Seleccione una ubicación en el mapa";
    }
  }

  onSetCoordinates(referencePoints: CoreTypes.ITS_ReferencePoints) {
    let latLng = new google.maps.LatLng(referencePoints.Latitude, referencePoints.Longitude);
    if(referencePoints.DescriptionDisplay) this.searchControl = referencePoints.DescriptionDisplay;
    this.latitude = referencePoints.Latitude;
    this.longitude = referencePoints.Longitude;
    this.coordinates = { Latitude: this.latitude, Longitude: this.longitude };
    if(this.displayOnModal) {
      this.getFormattedAddress(latLng);
    }else {
      this.onPlaceChange(null, latLng, true);
    }
  }

  appendModalBody(type) {
    setTimeout(() => {
      if(type === 'append') {
        document.getElementsByTagName('app-root')[0].appendChild(document.getElementById('confirm-remove-element'));
        document.getElementsByTagName('app-root')[0].appendChild(document.getElementById('edit-element'));
        document.getElementsByTagName('app-root')[0].appendChild(document.getElementById('exit-route'));
        document.getElementsByTagName('app-root')[0].appendChild(document.getElementById('map-details'));
      } else {
        document.getElementsByTagName('app-root')[0]?.removeChild(document.getElementById('confirm-remove-element'));
        document.getElementsByTagName('app-root')[0]?.removeChild(document.getElementById('edit-element'));
        document.getElementsByTagName('app-root')[0]?.removeChild(document.getElementById('exit-route'));
        document.getElementsByTagName('app-root')[0]?.removeChild(document.getElementById('map-details'));
      }
    }, 100);
  }
}
